function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

class HTMLUpdateUtility {
    #preProcessCallbacks = [];
    #postProcessCallbacks = [];

    constructor() {
    }

    addPreProcessCallback(callback) {
        this.#preProcessCallbacks.push(callback);
    }

    addPostProcessCallback(callback) {
        this.#postProcessCallbacks.push(callback);
    }

    /**
     * Used to swap an HTML node with a new node.
     * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
     *
     * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
     */
    viewTransition(oldNode, newContent) {
        this.#preProcessCallbacks.forEach((callback) => callback(newContent));

        const newNode = oldNode.cloneNode();
        HTMLUpdateUtility.setInnerHTML(newNode, newContent.innerHTML);
        oldNode.parentNode.insertBefore(newNode, oldNode);
        oldNode.style.display = 'none';

        this.#postProcessCallbacks.forEach((callback) => callback(newNode));

        setTimeout(() => oldNode.remove(), 1000);
    }

    // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    static setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
    }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');

    }, true);
}

function pauseAllMedia() {
    if (!window.otherSettings.enableMediaPause) {
        return;
    }
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*')
    });
    document.querySelectorAll('video').forEach((video) => video.pause())
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) {
            model.modelViewerUI.pause()
            const button = model.querySelector('.shopify-model-viewer-ui__button.shopify-model-viewer-ui__button--poster')
            if (button) button.removeAttribute('hidden')
        }
    })
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {bubbles: true})

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        const isMinusButton = event.target.name === 'minus';
        const isCartLineItemInput = this.input.name === 'updates[]';
        const isSingleQuantity = Number(this.input.value) === 1;

        if (isMinusButton && isCartLineItemInput && isSingleQuantity) {
            this.input.value = 0;
        } else {
            event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        }
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
    };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        const ageVerification = this.classList.contains('age-verification-modal');
        const sectionId = this.dataset.sectionId;
        const modalClose = this.querySelector('[id^="ModalClose-"]')
        if (modalClose) {
            modalClose.addEventListener(
                'click',
                this.hide.bind(this, false)
            );
        }
        if (!ageVerification) {
            this.addEventListener('keyup', (event) => {
                if (event.code.toUpperCase() === 'ESCAPE') {
                    this.hide();
                }
            });
            if (this.classList.contains('media-modal')) {
                this.addEventListener('pointerup', (event) => {
                    if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) {
                        this.hide();
                    }
                });
            } else if (this.classList.contains('popup-modal')) {
                let delay = parseInt(this.dataset.delay) * 1000
                setTimeout(() => {
                    if (!Shopify.designMode) {
                        if (!this.getLocalItem()) {
                            this.show();
                        }
                    }
                    this.addEventListener('click', (event) => {
                        if (event.target === this || event.target.closest('[data-bs-dismiss]')) {
                            this.setLocalItem();
                            this.hide();
                        }
                    });
                }, delay);
            } else {
                this.addEventListener('click', (event) => {
                    if (event.target === this) {
                        this.hide();
                    }
                });
            }
        } else {
            if (!this.getLocalItem()) {
                this.show();
            }
            modalClose.addEventListener('click', () => {
                this.hide()
            });
            modalClose.addEventListener('click', this.setLocalItem.bind(this));
        }
        if (Shopify.designMode) {
            this.moved = true;
            document.addEventListener('shopify:section:select', (event) => {
                if (event.detail.sectionId === sectionId) {
                    this.show();
                }
            });
            document.addEventListener('shopify:section:deselect', (event) => {
                if (event.detail.sectionId === sectionId) {
                    this.hide();
                }
            });
        }
    }

    getLocalItem() {
        return window.localStorage.getItem(this.id);
    }

    setLocalItem() {
        window.localStorage.setItem(this.id, JSON.stringify(new Date()));
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        this.style.display = "block";
        this.classList.add("show")
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        this.classList.remove("show");
        this.style.display = "none";
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    }
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.handleProductUpdate);
        this.initializeProductSwapUtility()
        this.quickViewModal = document.querySelector('quick-view-modal');
        this.isQuickViewActive = (this.quickViewModal && this.quickViewModal.classList.contains('show'));
        this.findQuickViewEl = (el) => {
            return (this.quickViewModal.querySelector((el)) ? this.quickViewModal.querySelector((el)) : undefined);
        }
        this.findEl = (el) => {
            return (this.isQuickViewActive ? this.findQuickViewEl(`[id="${el}"]`) : document.getElementById(`${el}`));
        }
    }

    initializeProductSwapUtility() {
        this.swapProductUtility = new HTMLUpdateUtility();
        this.swapProductUtility.addPreProcessCallback((html) => {
            html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'));
            return html;
        });
        this.swapProductUtility.addPostProcessCallback((newNode) => {
            window?.Shopify?.PaymentButton?.init();
            window?.ProductModel?.loadShopifyXR();
            publish(PUB_SUB_EVENTS.sectionRefreshed, {
                data: {
                    sectionId: this.dataset.section,
                    resource: {
                        type: SECTION_REFRESH_RESOURCE_TYPE.product,
                        id: newNode.querySelector('variant-selects').dataset.productId,
                    },
                },
            });
        });
    }

    handleProductUpdate(event) {
        const input = this.getInputForEventTarget(event.target);
        const targetId = input.id;
        const targetUrl = input.dataset.productUrl || this.dataset.url;
        const baseUrl = new URL(this.dataset.url, window.location.origin);
        const nextUrl = new URL(targetUrl, window.location.origin);
        const isProductSwap = nextUrl.pathname !== baseUrl.pathname;

        this.currentVariant = isProductSwap ? null : this.getVariantData(targetId);
        const sectionId = this.dataset.originalSection || this.dataset.section;
        this.updateSelectedSwatchValue(event);
        this.toggleAddButton(true, '', false);
        this.removeErrorMessage();

        let callback = () => {
        };
        if (isProductSwap) {
            this.updateURL(targetUrl);
            this.updateShareUrl(targetUrl);
            callback = this.swapProductCallback(sectionId);
        } else if (!this.currentVariant) {
            callback = (html) => {
                this.updateOptionValues(html);

                const selectedVariant = this.getSelectedVariantFromHTML(html);
                if (!selectedVariant) {
                    this.setUnavailable();
                    this.updatePickupAvailability();
                    return;
                }

                this.currentVariant = selectedVariant;
                this.updateVariantInput();
                this.updateURL();
                this.updateShareUrl();
                this.handleUpdateProductInfo(sectionId)(html);
            };
        } else {
            this.updateURL();
            this.updateVariantInput();
            this.updateShareUrl();
            callback = this.handleUpdateProductInfo(sectionId);
        }
        this.renderProductInfo(sectionId, targetId, callback, isProductSwap ? targetUrl : this.dataset.url);
    }

    getSelectedVariantFromHTML(html) {
        const selectedVariantEl = html.querySelector('variant-selects script[type="application/json"][data-selected-variant]');
        if (!selectedVariantEl) return null;
        try {
            return JSON.parse(selectedVariantEl.textContent);
        } catch (e) {
            return null;
        }
    }

    getSelectedOptionValues() {
        return Array.from(this.querySelectorAll('select, fieldset input:checked'))
          .map((element) => element.dataset.optionValueId)
          .filter(Boolean);
    }

    updateSelectedSwatchValue({target}) {
        const {value, tagName} = target;

        if (tagName === 'INPUT' && target.type === 'radio') {
            const selectedSwatchValue = target;
            if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
    }

    getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }

    getVariantDataElement(inputId) {
        return this.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
    }

    getWrappingSection(sectionId) {
        return (
            this.closest(`section[data-section="${sectionId}"]`) || // main-product
            this.closest(`quick-view-modal`)?.modalContent || // quick-view
            this.closest(`#shopify-section-${sectionId}`) || // featured-product
            null
        );
    }

    swapProductCallback(sectionId) {
        return (html) => {
            const oldContent = this.getWrappingSection(sectionId);
            if (!oldContent) {
                return;
            }

            document.getElementById(`ProductModal-${sectionId}`)?.remove();

            const response =
                html.querySelector(`section[data-section="${sectionId}"]`) /* main/quick-add */ ||
                html.getElementById(`shopify-section-${sectionId}`); /* featured product*/

            this.swapProductUtility.viewTransition(oldContent, response);
        };
    }

    handleUpdateProductInfo(sectionId) {
        return (html) => {
            this.updatePickupAvailability();
            this.updateMedia();
            const priceDestination = document.getElementById(`price-${this.dataset.section}`);
            const priceSource = html.getElementById(`price-${sectionId}`);
            const skuSource = html.getElementById(`Sku-${sectionId}`);
            const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
            const inventorySource = html.getElementById(`Inventory-${sectionId}`);
            const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

            const volumePricingSource = html.getElementById(`Volume-${sectionId}`);

            const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
            const pricePerItemSource = html.getElementById(`Price-Per-Item-${sectionId}`);

            const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
            const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
            const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

            if (volumeNote) volumeNote.classList.remove('hidden');
            if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
            if (qtyRules) qtyRules.classList.remove('hidden');
            if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
            if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
                skuDestination.innerHTML = skuSource.innerHTML;
                skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
            }
            if (volumePricingSource && volumePricingDestination) {
                volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
            }
            if (pricePerItemSource && pricePerItemDestination) {
                pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
                pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
            }

            const price = document.getElementById(`price-${this.dataset.section}`);
            if (price) price.classList.remove('hidden');

            if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

            this.toggleAddButton(!this.currentVariant.available);

            this.updateOptionValues(html);

            publish(PUB_SUB_EVENTS.variantChange, {
                data: {
                    sectionId,
                    html,
                    variant: this.currentVariant,
                },
            });
        };
    }

    updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) this.innerHTML = variantSelects.innerHTML;
    }

    getInputSelector() {
        return 'variant-selects fieldset input[type="radio"], variant-selects select option';
    }

    updateURL(url = this.dataset.url) {
        if (this.dataset.updateUrl === 'false') return;
        if (url && url !== this.dataset.url) {
          window.history.replaceState({}, '', url);
          return;
        }
        if (!this.currentVariant) return;
        const baseUrl = url || this.dataset.url;
        window.history.replaceState({}, '', `${baseUrl}${this.currentVariant?.id ? `?variant=${this.currentVariant.id}` : ''}`);
    }

    updateShareUrl(url = this.dataset.url) {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        const baseUrl = url || this.dataset.url;
        shareButton.updateUrl(
            baseUrl.startsWith('http')
              ? baseUrl
              : `${window.shopUrl}${baseUrl}${
                  baseUrl !== this.dataset.url || !this.currentVariant?.id ? '' : `?variant=${this.currentVariant.id}`
                }`
        );
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            const priceRequest = document.querySelector('#product-price-request');
            if (priceRequest) {
                let options = productForm.querySelector('input[name="contact[product-options]"]');
                let sku = productForm.querySelector('input[name="contact[product-sku]"]');
                let urlInput = productForm.querySelector('input[name="contact[product-url]"]');
                let url = new URL(urlInput.value);
                options.value = JSON.stringify(this.currentVariant.options);
                sku.value = this.currentVariant.sku;
                url.searchParams.set('variant', this.currentVariant.id)
                urlInput.value = url.href;
            }
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {bubbles: true}));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo(sectionId, targetId, callback, url = this.dataset.url) {
        const baseUrl = url || this.dataset.url;
        const requestUrl = new URL(baseUrl, window.location.origin);
        requestUrl.searchParams.set('section_id', sectionId);

        if (this.currentVariant?.id) {
          requestUrl.searchParams.set('variant', this.currentVariant.id);
          requestUrl.searchParams.delete('option_values');
        } else {
          requestUrl.searchParams.delete('variant');
          const optionValues = this.getSelectedOptionValues();
          if (optionValues.length) {
            requestUrl.searchParams.set('option_values', optionValues.join(','));
          } else {
            requestUrl.searchParams.delete('option_values');
          }
        }

        this.abortController?.abort();
        this.abortController = new AbortController();

        const variantChangeEvent = new Event("variant:changed");

        const loader = this.isQuickViewActive ? this.findQuickViewEl('.js-quickview-loader') : document.querySelector('.js-product-loader')
        if (loader) window.Global.showLoader(loader);

        fetch(requestUrl.toString(), {signal: this.abortController.signal,})
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                callback(html)
            })
            .finally(() => {
                let image = document.querySelector('.gallery-wrapper > .js-product-gallery > div > ul > li > div > picture > img');
                if (image && !image.complete && image.loading !== 'lazy') {
                    image.addEventListener('load', () => {
                        if (loader) window.Global.hideLoader(loader);
                    })
                } else {
                    if (loader) window.Global.hideLoader(loader);
                }
                document.dispatchEvent(variantChangeEvent);
            });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const activeMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        const quickviewActiveMedia = document.querySelectorAll(
            `quick-view-modal [data-media-id*="${this.currentVariant.featured_media.id}"]`
        );

        if (activeMedia.length || quickviewActiveMedia.length) {
            // 1) Update DOM first so both desktop and mobile sliders see the correct active media as slide 0
            if (activeMedia.length) {
                activeMedia.forEach((media) => {
                    // detail view main image
                    let main_image = media.querySelector('picture > img.main_image');
                    if (main_image) {
                        main_image.removeAttribute('loading');
                    }
                    this.reinitGalleryThumbnails(media);
                });
            } else if (quickviewActiveMedia.length) {
                // quick view main image
                quickviewActiveMedia.forEach((media) => {
                    const mainImage = media.querySelector('picture > img');
                    if (mainImage) {
                        mainImage.removeAttribute('loading');
                    }
                    this.reinitGalleryThumbnails(media);
                });
            }

            // 2) Destroy all existing product gallery sliders (desktop + mobile have different IDs),
            //    then trigger a single 'variant-changed' so GenericSlider can re‑initialize them.
            const sliders = document.querySelectorAll(`.js-product-gallery[data-generic-slider*="-product-gallery-"]`);
            if (sliders && sliders.length) {
                let hadInstances = false;
                sliders.forEach((el) => {
                    const glideId = el.dataset.genericSlider;
                    if (window.glideInstances && window.glideInstances[glideId]) {
                        window.glideInstances[glideId].destroy();
                        delete window.glideInstances[glideId];
                        hadInstances = true;
                    }
                });

                if (hadInstances) {
                    document.body.dispatchEvent(new CustomEvent('variant-changed'));
                }
            }
        }
    }

    reinitGalleryThumbnails(media) {
        const parentEl = media.parentElement;
        if (!parentEl) return;

        // Move active media to the beginning so it becomes slide 0 for both desktop and mobile galleries
        parentEl.prepend(media);

        if (parentEl.classList.contains('js-gallery-thumbnails')) {
            const visibleThumbnails = [...parentEl.querySelectorAll('.js-thumbnail-visible')];
            const activeWasHidden = media.classList.contains('hidden');

            // Only shift visibility when the active thumbnail was previously hidden (e.g. behind a "+N more" control)
            if (activeWasHidden) {
                const lastVisibleThumbnail = visibleThumbnails[visibleThumbnails.length - 1];
                if (lastVisibleThumbnail && lastVisibleThumbnail !== media) {
                    lastVisibleThumbnail.classList.remove('js-thumbnail-visible');
                    lastVisibleThumbnail.classList.add('hidden');
                }

                media.classList.add('js-thumbnail-visible');
                media.classList.remove('hidden');
            }
        }

        // Re-number slide indices so data-slide-id / data-glide-dir stay in sync with DOM order
        const slides = [...parentEl.children];
        if (slides && slides.length) {
            let slideId = 0;
            slides.forEach((el) => {
                const hasSlideId = el.dataset.slideId !== undefined;
                const hasGlideDir = el.dataset.glideDir !== undefined;

                if (hasSlideId) {
                    el.dataset.slideId = slideId.toString();
                }

                if (hasGlideDir) {
                    el.dataset.glideDir = '=' + slideId.toString();
                }

                if (hasSlideId || hasGlideDir) {
                    slideId++;
                }
            });
        }
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.findEl(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');

        const stockWrapper = this.isQuickViewActive ? this.findQuickViewEl('.js-stock-wrapper') : document.querySelector('.js-stock-wrapper');
        const inventoryHtml = `${this.currentVariant ? "" : ""} ${window.variantStrings.lessThan10Products}`;

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (this.currentVariant && this.currentVariant.inventory_management === 'shopify' && stockWrapper) {
            stockWrapper.classList.remove('hidden')
            const productStockState = stockWrapper.querySelector('.product-stock-state');

            if (this.currentVariant.available) {
                const availableInventoryNote = productStockState.querySelector('.product-stock-state .js-inventory');
                productStockState.classList.remove('out-of-stock', 'hidden')
                productStockState.classList.add('on-stock')
                availableInventoryNote.textContent = inventoryHtml;
            } else {
                productStockState.classList.remove('on-stock')
                productStockState.classList.add('out-of-stock')
            }
        } else if (stockWrapper) {
            stockWrapper.classList.add('hidden')
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = this.findEl(`product-form-${this.dataset.section}`);
        if (!button) return;
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData(inputId) {
        return JSON.parse(this.getVariantDataElement(inputId).textContent);
    }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();

        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }
                })
                .finally(() => {
                    const event = new CustomEvent('product-recommendations-loaded', {detail: this})
                    document.body.dispatchEvent(event)
                })
        }
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
}

customElements.define('product-recommendations', ProductRecommendations);

class BulkAdd extends HTMLElement {
    constructor() {
        super();
        this.queue = [];
        this.requestStarted = false;
        this.ids = [];
    }

    startQueue(id, quantity) {
        this.queue.push({id, quantity});
        const interval = setInterval(() => {
            if (this.queue.length > 0) {
                if (!this.requestStarted) {
                    this.sendRequest(this.queue);
                }
            } else {
                clearInterval(interval);
            }
        }, 250);
    }

    sendRequest(queue) {
        this.requestStarted = true;
        const items = {};
        queue.forEach((queueItem) => {
            items[parseInt(queueItem.id)] = queueItem.quantity;
        });
        this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
        const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
        quickBulkElement.updateMultipleQty(items);
    }

    resetQuantityInput(id) {
        const input = this.querySelector(`#Quantity-${id}`);
        input.value = input.getAttribute('value');
        this.isEnterPressed = false;
    }

    setValidity(event, index, message) {
        event.target.setCustomValidity(message);
        event.target.reportValidity();
        this.resetQuantityInput(index);
        event.target.select();
    }

    validateQuantity(event) {
        const inputValue = parseInt(event.target.value);
        const index = event.target.dataset.index;

        if (inputValue < event.target.dataset.min) {
            this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
        } else if (inputValue > parseInt(event.target.max)) {
            this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
        } else if (inputValue % parseInt(event.target.step) != 0) {
            this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
        } else {
            event.target.setCustomValidity('');
            event.target.reportValidity();
            this.startQueue(index, inputValue);
        }
    }

    getSectionsUrl() {
        if (window.pageNumber) {
            return `${window.location.pathname}?page=${window.pageNumber}`;
        } else {
            return `${window.location.pathname}`;
        }
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
}

if (!customElements.get('bulk-add')) {
    customElements.define('bulk-add', BulkAdd);
}